import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FoodcourtService } from 'src/app/services/foodcourt.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-vendor',
  templateUrl: './remove-modal-vendor.component.html',
  styleUrls: ['./remove-modal-vendor.component.scss'],
})
export class RemovemodalvendorComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() foodCourtVendorId: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private foodcourtService: FoodcourtService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteVendorData() {
    this.listCouponIds = [];
    if (this.fromDetailsPage == 'yes') {
      this.foodcourtService
        .removeVendor(this.foodCourtVendorId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            this.router.navigate(['/list-food-vendor/']);
          }
        });
    }
    if (this.fromDetailsPage == 'no') {
      this.foodcourtService
        .removeVendorBulk(this.foodCourtVendorId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
    }
    this.modal.dismiss();
  }
}
